export default {
  success: '',
  error: false,
  errorMessages: [],
  setError: function (message) {
    this.success = ''
    this.error = !!message === true
    if (!!message === true) { this.errorMessages.push(message) } else { this.errorMessages = [] }
  },
  setSuccess: function (message) {
    this.success = message
  },
}
